import PropTypes from "prop-types";
import React from "react";
import Slider from "react-slick";

export function Carousel({ slides, options }) {
	const settings = {
		dots: true,
		infinite: false,
		arrows: false,
		speed: 400,
		slidesToShow: 2,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
		customPaging: (index) => <button>Page {index + 1}</button>,
		...options,
	};
	return <Slider {...settings}>{slides}</Slider>;
}

Carousel.propTypes = {
	slides: PropTypes.arrayOf(PropTypes.element).isRequired,
	options: PropTypes.object,
};
